import React, { useState, useEffect } from "react";
import { useParams,useNavigate,Link } from 'react-router-dom';
import axios from 'axios';

import HeaderTitle from "../../components/includes/HeaderTitle";

import { isEmptyObj,isOnlyNumber,isExceptKoreanString,ChangeMobileFormat,ChangeMobileNumber,ChangeDateStringOnlyDate,ChangeSearchingDateFormat,ShowDeliveryStatus } from "../../../components/common/Common";

//건의 정보 편집
function DriverDetail({setMenuType,setMenuItem}) {
  const admin_idx = Number(localStorage.getItem('adminIdx'));
  let { drMode,dr_idx } = useParams();
  const navigator = useNavigate();

  //건의 변수 저장 객체
  const newData = {      
    dr_idx: 0,
    dr_reg_idx:admin_idx,
    dr_mem_idx:0,
    mem_idx:0,
    mem_id: "",
    mem_pwd: "",
    mem_name: "",
    mem_mobile: "",
    mem_email:"",
    dr_carnumb: "",
    mem_rdate:ChangeSearchingDateFormat(new Date(),'.'),
    mem_status:1,
    chk_id:0
  };

  //건의정보
  const [varDriverInfo,setDriverInfo] = useState({});
  const [varDeliveryList,setDeliveryList] = useState([]);
  const [varStaffList,setStaffList] = useState([]);
  const [varReceiptList,setReceiptList] = useState([]);
  
  //건의정보 읽어오기
  const getDriverInformation = async () => {
    var sendData = {dr_idx: dr_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_driver_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      let bset = false;
      if(datas.retvalue === 1) {
        if(datas.results?.length > 0) {
          bset = true;
          let driverData = datas.results[0];
          driverData.mem_pwd = "";
          setDriverInfo(driverData);
        }
        setDeliveryList(datas.deliverys);
        setReceiptList(datas.receipts);
        setStaffList(datas.staffs);
      }
      if(!bset) setDriverInfo(newData);
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    setMenuType('DRIVER');
    setMenuItem('DriverList');
    getDriverInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //회원정보편집
  const onDriverInfoHandler = (e) => {
    const {name,value} = e.currentTarget;
    if(name === "mem_id") {
      const svalue = isExceptKoreanString(value);
      if(varDriverInfo.chk_id === 1) {
        setDriverInfo({...varDriverInfo, [name]:svalue,chk_id:0});
      } else {
        setDriverInfo({...varDriverInfo, [name]:svalue});
      }
    } else if(name === "mem_mobile") {
      setDriverInfo({...varDriverInfo, [name]:ChangeMobileNumber(value)});
    } else if(name === "mem_pwd") {
      let svalue = isOnlyNumber(value);
      setDriverInfo({...varDriverInfo, [name]:svalue});
    } else {
      setDriverInfo({...varDriverInfo, [name]:value});
    }
  }

  //건의정보 저장
  const onUpdateDriverHandler = async (e) => {
    if(varDriverInfo.mem_id === "") {
      alert('아이디를 먼저 입력하세요'); return false;
    } else if(varDriverInfo.chk_id === 0) {
      alert('아이디의 중복검사를 먼저 실행하세요'); return false;
    } else if(varDriverInfo.mem_name === "") {
      alert('이름을 먼저 입력하세요'); return false;
    } else if(varDriverInfo.mem_mobile === "") {
      alert('연락처를 먼저 입력하세요'); return false;
    } else if(varDriverInfo.dr_carnumb === "") {
      alert('차량번호를 먼저 입력하세요'); return false;
    }

    if(varDriverInfo.dr_idx === 0) {
      if(varDriverInfo.mem_pwd === "") {
        alert('비밀번호를 먼저 입력하세요'); return false;
      } else if(varDriverInfo.mem_pwd.length !== 4) {
        alert('입력한 비밀번호가 형식이 맞지않습니다. 확인후 다시 입력하세요'); return false;
      }
    } else {
      if(varDriverInfo.mem_pwd !== "") {
        if(varDriverInfo.mem_pwd.length !== 4) {
          alert('입력한 비밀번호가 형식이 맞지않습니다. 확인후 다시 입력하세요'); return false;
        }
      }
    }

    let prompt = "현재 입력된 기사 정보를 저장합니까?";
    if(varDriverInfo.dr_idx === 0)  prompt = "입력하신 기사 정보를 등록합니까?";
    if(!window.confirm(prompt)) return false;

    const sendData = {dataInfo:varDriverInfo};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_update_driver_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      alert(datas.message);
      if(datas.retvalue === 1) {
        //목록페이지로 이동
        navigator(`/Admin/DriverList/${drMode}`);
      }
    });
  }

  //배차목록
  const [varPopupDelivery,setPopupDelivery] = useState(false);
  const onOpenDeliveryList = (e) => {
    setPopupReceipt(false);
    setPopupDelivery(true);
  }
  //인수증목록
  const [varPopupReceipt,setPopupReceipt] = useState(false);
  const onOpenReceiptList = (e) => {
    setPopupDelivery(false);
    setPopupReceipt(true);
  }

  //아이디 중복검사
  const onCheckDuplicationIDHandler = async(e) => {
    if(varDriverInfo.mem_id === "") {
      alert('검색할 아이디를 먼저 입력하세요.');return false;
    }
    const sendData = {mem_id:varDriverInfo.mem_id};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_check_duplicate_id`,sendData).then((res) => {
      const datas = res.data;
      if(datas.retvalue === 1) {
        setDriverInfo({...varDriverInfo,chk_id:1});
      } else {
        setDriverInfo({...varDriverInfo,mem_id:""});
      }
      alert(datas.message);
    });
  }

  return isEmptyObj(varDriverInfo)?null:(
    <div id="admin_contents" className="ad_contents">
      <HeaderTitle varMenuTitle="기사 관리" varPageTitle={varDriverInfo.dr_idx===0?"기사등록":"기사상세"} />
      <div className="admin-content">
        {varDriverInfo.dr_idx===0?null:
          <div className="btn-right">
            {varDeliveryList?.length===0?null:<button onClick={(e)=>onOpenDeliveryList(e)} className="btn line black">배차 목록</button>}
            {varReceiptList?.length===0?null:<button onClick={(e)=>onOpenReceiptList(e)} className="btn line">등록 인수증</button>}
          </div>
        }
        {/* 배차 목록 */}
        <div className="main-box" style={varPopupDelivery?{display:"block"}:{display:"none"}}>
          <table className="list">
            <colgroup>
              <col style={{width:"50px"}}/><col style={{width:"150px"}}/><col style={{width:"250px"}}/><col style={{width:"100px"}}/><col style={{width:"100px"}}/>
            </colgroup>
            <thead>
              <tr><th>번호</th><th>상차일</th><th>상차지</th><th>상태</th><th>상세</th></tr>
            </thead>
            <tbody>
              {varDeliveryList.map((delivery, i) => (
                <tr key={'delivery_'+i}>
                  <td>{i+1}</td>
                  <td>{ChangeDateStringOnlyDate(delivery.dc_riding_date)}</td>
                  <td>{delivery.dc_riding_address}</td>
                  <td>{ShowDeliveryStatus(delivery.dc_status)}</td>
                  <td><Link to={`/Admin/DeliveryDetail/${delivery.dc_idx}`} style={{width:"70px"}} className="btn line black">상세</Link></td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="btn-right">
            <Link to={`/Admin/DeliveryList`} className="btn line">더보기</Link>
            <button className="btn line" onClick={()=>setPopupDelivery(false)}>닫기</button>
          </div>
        </div>
        {/* 등록 인수증 */}
        <div className="main-box" style={varPopupReceipt?{display:"block"}:{display:"none"}}>
          <table className="list">
            <colgroup>
              <col style={{width:"50px"}}/><col style={{width:"150px"}}/><col style={{width:"250px"}}/><col style={{width:"100px"}}/><col style={{width:"100px"}}/>
            </colgroup>
            <thead>
              <tr><th>번호</th><th>상차일</th><th>상차지</th><th>상태</th><th>상세</th></tr>
            </thead>
            <tbody>
              {varReceiptList.map((receipt, i) => (
                <tr key={'receipt_'+i}>
                  <td>{i+1}</td>
                  <td>{ChangeDateStringOnlyDate(receipt.dc_riding_date)}</td>
                  <td>{receipt.dc_riding_address}</td>
                  <td>{ShowDeliveryStatus(receipt.dc_status)}</td>
                  <td><Link to={`/Admin/DeliveryDetail/${receipt.dc_idx}`} style={{width:"70px"}} className="btn line black">상세</Link></td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="btn-right">
            {/* <Link to={`/Admin/ReceiptList`} className="btn line">더보기</Link> */}
            <button className="btn line" onClick={()=>setPopupReceipt(false)}>닫기</button>
          </div>
        </div>
        {/* 기사 등록/편집 */}
        <div className="main-box">
          <table className="write" style={{borderTop:"solid 1px #eee"}}>
            <colgroup>
              <col width="20%"></col>
              <col width="80%"></col>
            </colgroup>
            <thead></thead>
            <tbody>
              <tr>
                <th>등록일</th>
                <td>{ChangeDateStringOnlyDate(varDriverInfo.mem_rdate||"")}</td>
              </tr>
              <tr>
                <th>아이디</th>
                <td>
                  <input type="text" name="mem_id" value={varDriverInfo.mem_id||""} style={{width:"300px"}} onChange={(e)=>onDriverInfoHandler(e)}/>
                  <button className="btn line" onClick={e=>onCheckDuplicationIDHandler(e)}>중복검사</button>
                </td>
              </tr>
              <tr>
                <th>비밀번호</th>
                <td>
                  <input type="password" name="mem_pwd" value={varDriverInfo.mem_pwd||""} style={{width:"300px"}} maxLength={4} onChange={(e)=>onDriverInfoHandler(e)}/>
                  <div style={{color:"red",fontSize:"14px"}}>비밀번호는 숫자로 4자리입니다.</div>
                </td>
              </tr>
              <tr>
                <th>이름</th>
                <td><input type="text" name="mem_name" value={varDriverInfo.mem_name||""} style={{width:"70%"}} onChange={(e)=>onDriverInfoHandler(e)}/></td>
              </tr>
              <tr>
                <th>연락처</th>
                <td><input type="text" name="mem_mobile" value={ChangeMobileFormat(varDriverInfo.mem_mobile||"")} style={{width:"50%"}} onChange={(e)=>onDriverInfoHandler(e)}/></td>
              </tr>
              <tr>
                <th>이메일</th>
                <td><input type="text" name="mem_email" value={varDriverInfo.mem_email||""} style={{width:"80%"}} onChange={(e)=>onDriverInfoHandler(e)}/></td>
              </tr>
              <tr>
                <th>차량번호</th>
                <td><input type="text" name="dr_carnumb" value={varDriverInfo.dr_carnumb||""} style={{width:"50%"}} onChange={(e)=>onDriverInfoHandler(e)}/></td>
              </tr>
              <tr>
                <th>배차담당자</th>
                <td>
                  <select name="dr_reg_idx" value={varDriverInfo.dr_reg_idx} style={{width:"200px"}} onChange={(e)=>onDriverInfoHandler(e)}>
                    {varStaffList.map((staff,i)=>(
                      <option value={staff.mem_idx}>{staff.mem_name}</option>
                    ))}
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
          <div className="btn-center">
            <button className="btn line black" style={{width:"100px"}} onClick={(e)=>onUpdateDriverHandler(e)}>저장</button>
            <Link to={`/Admin/DriverList/${drMode}`} style={{width:"100px"}} className="btn line">목록</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DriverDetail;